import React from 'react';
import PropTypes from 'prop-types';
import styles from './SkinItem.module.scss'; //using-css-modules-in-react. Ref: https://blog.openreplay.com/using-css-modules-in-react/

function SkinItem({ children }) {
    return <div className={`${styles.section} ${styles['section--border']} `}>{children}</div>;
}

SkinItem.propTypes = {
    children: PropTypes.node.isRequired,
};
export default SkinItem;
